import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  constructor(
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let request = req;
    if(req.url.startsWith(environment.api)){
      
      try{
          const token: string = JSON.parse(localStorage.getItem('user')).token;
      
          if (token) {
            request = req.clone({
              setHeaders: {
                'X-Auth-Token': `${ token }`
              }
            });
          }
      }
      catch(e){
  
      }
    }
    

    return next.handle(request);
  }

}